import { computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia';
import useTlmCart from '@/composable/useTlmCart';
import { useReceiptStore } from '~/stores/useReceiptStore';
import { patchDeviceLineItemPricesInCart } from '~/composable/voucher/resolveDevicePriceForCart';
import { useResolveVoucherDevicePrice } from '~/composable/voucher/useResolveVoucherDevicePrice';

const sanitizeReceiptCart = (cart) => {
  if (!cart?.cartItemGroupList) {
    return cart
  }

  return {
    ...cart,
    cartItemGroupList: cart.cartItemGroupList.map((group) => ({
      ...group,
      cartItems: (group.cartItems || []).filter((item) => item?.cartProduct)
    }))
  }
}

export const useReceipt = (app) => {
  if (!app) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const receiptStore = useReceiptStore()
  const {
    receiptData,
    loading
  } = storeToRefs(receiptStore)
  const tlmCart = useTlmCart(app, receiptData, { receiptMode: true })
  const { resolveFromCartItem, getPdpProductBundlePrice } = useResolveVoucherDevicePrice()

  const storeReceiptData = (res, trackingSnapshot = null) => {
    const patchedCart = patchDeviceLineItemPricesInCart(res, {
      resolveFromCartItem,
      getPdpProductBundlePrice
    })
    receiptData.value = sanitizeReceiptCart({
      ...patchedCart,
      trackingSnapshot: trackingSnapshot || receiptData.value?.trackingSnapshot || null
    })
    loading.value = false
  }

  const isCartEmpty = computed(() => {
    if (loading.value) {
      return false
    }
    return !!receiptData.value?.cartEmpty
  })

  return {
    ...tlmCart,

    storeReceiptData,
    receiptData,
    cart: computed(() => receiptData.value),
    isCartEmpty,
    isLoading: computed(() => loading.value)
  }
}
